<div class="scout-dialog">
  <button
    class="close-btn"
    mat-icon-button
    (click)="close()"
    aria-label="Close Meta Scout Info"
  >
    ×
  </button>

  <div class="header">
    <img src="assets/logos/meta.svg" alt="Meta Scout Logo" class="mini-logo" />
    <h2>Meta&nbsp;Scout</h2>
    <div class="sub">Efficient, fast, and production-friendly — designed for low-latency assistants and scalable apps</div>
  </div>

  <div class="body">
    <p>
      <strong>Meta&nbsp;Scout</strong> is built for teams that need <strong>speed</strong>, <strong>cost efficiency</strong>,
      and <strong>reliable everyday performance</strong>. It’s a strong choice when you want a model that feels responsive
      in real products—chat, Q&amp;A, summarization, light coding help—without the heavier latency and infrastructure needs
      of larger frontier models.
    </p>

    <ul>
      <li>⚡ <strong>Low-latency inference:</strong> fast responses that work well for real-time UX and high-traffic workloads.</li>
      <li>💸 <strong>Cost-efficient serving:</strong> smaller footprint and lower compute needs—good for budget-sensitive deployments.</li>
      <li>🧾 <strong>Strong general utility:</strong> handles chat, short reasoning, summarization, extraction, and rewrite tasks.</li>
      <li>👨‍💻 <strong>Helpful for code workflows:</strong> good for completions, small fixes, explanations, and pattern-based refactors.</li>
      <li>🔁 <strong>Multi-turn stability:</strong> stays coherent across back-and-forth conversations and instruction-following.</li>
      <li>🧩 <strong>Easy to integrate:</strong> great fit for assistants, RAG pipelines, and tool-using agents where speed matters.</li>
    </ul>

    <div class="optimal">
      <h3>Best used for</h3>
      <ul>
        <li><strong>High-traffic chatbots:</strong> instant replies for support, onboarding, and product guidance</li>
        <li><strong>RAG assistants:</strong> fast Q&amp;A over internal docs when retrieval provides the facts</li>
        <li><strong>Summarization &amp; extraction:</strong> tickets, call notes, emails, and structured data from text</li>
        <li><strong>Real-time suggestions:</strong> content hints, autocomplete, short copy drafts, and micro-edits</li>
        <li><strong>Edge / cost-sensitive environments:</strong> where footprint and throughput are key constraints</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>How to get the best results</h3>
      <ul>
        <li><strong>Keep prompts tight:</strong> give a clear goal + required format (bullets, JSON, short answer).</li>
        <li><strong>Use retrieval for facts:</strong> pair Scout with RAG to keep answers grounded and accurate.</li>
        <li><strong>Reserve heavy reasoning:</strong> for deep analysis, route to a larger “reasoning” model when needed.</li>
        <li><strong>Standardize outputs:</strong> templates and schemas help keep responses consistent at scale.</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Tip</h3>
      <ul>
        <li>
          Use Scout when you want <strong>great responsiveness</strong> and <strong>strong everyday accuracy</strong> with minimal overhead.
          For long, complex reasoning or high-stakes analysis, switch to a deeper reasoning model.
        </li>
      </ul>
    </div>
  </div>
</div>
